import React, { useState } from 'react';

//styling
import './MultiSelect.css';

const MultiSelect = (props) => {

    const {
        currentQuestion,
        questionAnswerOptions,
        onSelectedOptionsSubmitted
    } = props;

    const [selectedOptions, setSelectedOptions] = useState([]);

    const onOptionSelectedChange = (value) => {
      let selectedOptionsArr = [...selectedOptions];
      let valueIndex = selectedOptions.indexOf(value);
      valueIndex > -1 ? selectedOptionsArr.splice(valueIndex) : selectedOptionsArr.push(value);
      setSelectedOptions(selectedOptionsArr);
    }

    const submitSelectedOptions = () => {
      onSelectedOptionsSubmitted(selectedOptions.join(', '));
    }

    return (<div>
        <div>
            <p>Select all that apply: </p>
            {
              questionAnswerOptions.map((option, key) => { 
                  return <div key={key} className={selectedOptions.indexOf(option) > -1 ? "answerOptionsSelected" : "answerOptions" } value={option} onClick={()=>onOptionSelectedChange(option)}>{option}</div>
              })
            }

            <button className="submitButton" onClick={submitSelectedOptions}>Apply</button>
        </div>
    </div>);
}

export default MultiSelect;